var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFujitsuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_367_43)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4736 25.2336C28.3267 25.146 30.0981 21.1186 29.9958 18.2759C29.8372 13.9258 26.2085 11.4411 23.2424 11.5011C20.2821 11.5625 18.3032 14.2854 18.3032 14.2854V18.3343C18.3032 18.3343 18.8873 16.4013 20.1636 15.129C21.4458 13.8628 22.5709 13.6292 23.4232 13.6216C24.7113 13.6077 28.0065 14.8309 28.0065 18.1576C28.0065 21.4812 25.7875 22.6921 24.3007 22.9963C21.8475 23.4942 20.1636 22.0313 18.8873 20.2166C17.608 18.3942 16.1613 17.5522 14.467 17.4892C12.7831 17.4246 9.1217 18.7615 9.00312 22.5691C8.89046 26.3691 11.8521 28.5573 14.3588 28.4989C16.8491 28.4328 18.2528 26.6841 18.2528 26.6841V23.6002C18.2528 23.6002 16.9573 26.5704 14.2847 26.4982C11.3852 26.4383 10.9272 23.7892 10.9865 22.6905C11.0384 21.5996 12.0271 19.4837 14.2387 19.5497C16.4444 19.6097 17.3249 21.4182 17.7251 21.9038C18.1357 22.3801 19.8775 25.2874 23.4736 25.2336Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_367_43",
    x1: 0,
    y1: 20,
    x2: 40,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05A826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCA08"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFujitsuIcon);
export default __webpack_public_path__ + "static/media/fujitsu_icon.e5155a16ff34a3c4ec6fced92ed9b3d7.svg";
export { ForwardRef as ReactComponent };